import { Box, Divider, Paragraph } from '@zillow/constellation-10';
import { ForwardedRef, forwardRef } from 'react';
import StatusLabel from '../../../StatusLabel';
import ConditionalWrapper from '../../../ConditionalWrapper';

type Props = WithChildren<{
  isBackgroundHighlighted?: boolean;
  shouldShowExpiredStatusLabel?: boolean;
  title?: string;
}>;

const InboxSidebarSection = forwardRef(
  (
    { children, isBackgroundHighlighted = false, shouldShowExpiredStatusLabel = false, title = '' }: Props,
    ref: ForwardedRef<HTMLDivElement>,
  ): JSX.Element => {
    return (
      <>
        <Divider css={{ marginBlock: 'loose' }} />

        <Box
          ref={ref}
          css={{
            transition: 'visibility 0s, opacity 2s ease',
            backgroundColor: isBackgroundHighlighted ? 'blue.100' : 'transparent',
          }}
        >
          <ConditionalWrapper
            shouldRenderWrapperElement={shouldShowExpiredStatusLabel}
            wrapper={(children) => (
              <Box css={{ display: 'flex', justifyContent: 'space-between', marginBottom: 'tight' }}>
                {children}
                <StatusLabel text="Expired" linkId="statusLabelExpired" />
              </Box>
            )}
          >
            <Paragraph textStyle="body-bold" css={{ ...(!shouldShowExpiredStatusLabel && { marginBottom: 'tight' }) }}>
              {title}
            </Paragraph>
          </ConditionalWrapper>

          {children}
        </Box>
      </>
    );
  },
);

InboxSidebarSection.displayName = 'InboxSidebarSection';
export default InboxSidebarSection;
